Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    /*
     * Note:
     * A pageSize has not been set for albums and mediaItems (e.g. request minimum 10 albums)
     * because the API has a bug: https://issuetracker.google.com/issues/117894760
     */

    var request = {
        mediaItems: 'https://photoslibrary.googleapis.com/v1/mediaItems',
        albums: 'https://photoslibrary.googleapis.com/v1/albums'
    };

    Entities.GoogleAlbums = Entities.PaginatedCollection.extend({
        initialize: function(models, options) {
            this.token = options.token;
            this.nextPageToken = null;
        },
        server_api: {
            pageToken: function() {
                return this.nextPageToken;
            }
        },
        parse: function(e) {
            return e.albums;
        },
        loadMore: function() {
            this.fetch({
                headers: {
                    'Authorization': this.token
                },
                success: function(collection, response, options) {
                    // check for more items to load
                    this.nextPageToken = response.nextPageToken || null;
                    collection.nextPageToken = this.nextPageToken;
                },
                add: true,
                reset: false,
                remove: false
            });
        }
    });

    Entities.GooglePhotos = Entities.PaginatedCollection.extend({
        initialize: function(models, options) {
            this.token = options.token;
            this.nextPageToken = null;
            this.filter = null;
            this.loading = false;
            this.categories = [];
            this.date = {
                year: 0,
                month: 0,
                day: 0
            };
        },
        server_api: {
            pageToken: function() {
                return this.nextPageToken;
            }
        },
        parse: function(e) {
            return e.mediaItems;
        },
        setCategoryFilter: function(filter) {
            this.categories = filter;
        },
        setMediaFilter: function(filter) {
            this.media = filter;
        },
        setYearFilter: function(year) {
            this.date.year = year;
        },
        setMonthFilter: function(month) {
            this.date.month = month;
        },
        setDayFilter: function(day) {
            this.date.day = day;
        },
        setDefaultDateValues: function() {
            // setting a date item as 0 is the same as setting it to none
            this.date = {
                year: 0,
                month: 0,
                day: 0
            };
        },
        setDefaultFilterValues: function() {
            this.setDefaultDateValues();
            this.media = 'ALL_MEDIA';
            this.categories = [];
        },
        fetchWithFilters: function() {
            var data = {
                'filters': {
                    'contentFilter': {
                        'includedContentCategories': this.categories
                    },
                    'mediaTypeFilter': {
                        'mediaTypes': this.media
                    }
                }
            };

            /*
             * Google Photos API throws invalid date error if 0 is submitted in request
             * so we only add it to the data object when date filters are selected
             */
            if (this.date.year !== 0 || this.date.month !== 0 || this.date.day !== 0) {
                data['filters']['dateFilter'] = {
                    'dates': [{
                        'year': this.date.year,
                        'month': this.date.month,
                        'day': this.date.day
                    }]
                };
            }

            App.execute('google:photos:filter:event', 'Apply Google Photos Filter', {
                categories: this.categories,
                date: this.date,
                media_type: this.media
            });

            // set filter so it can be used to fetch more photos with the same filters later
            this.filter = data;

            $.ajax({
                url: request.mediaItems + ':search',
                type: 'POST',
                data: JSON.stringify(this.filter),
                contentType: 'application/json',
                context: this,
                headers: {
                    'Authorization': this.token
                },
                success: function(resp) {
                    // check for more items to load
                    this.nextPageToken = resp.nextPageToken || null;
                    this.loading = false;

                    // check for results
                    if (resp.mediaItems) {
                        this.set(resp.mediaItems);
                    } else {
                        /*
                         * Passing an empty array still returns mediaItems,
                         * so we need to remove models entirely
                         */
                        this.remove(this.models);
                    }
                    // ajax doesn't trigger sync by default, unlike fetch
                    this.trigger('sync');
                }
            });
        },

        loadMore: function(album, filter) {
            var data = '';

            // nextPageToken determines if there are more photos to load
            var nextPage = {
                'pageToken': this.nextPageToken
            };

            /*
             * v1 API Note:
             * album and filter data must be separate objects
             * because albumId cannot be set in conjunction with any filters;
             * an error will occur otherwise.
             */

            // fetch more photos from that album
            if (album) {
                data = JSON.stringify(_.extend(nextPage, {
                    'albumId': album.id
                }));
            }

            // fetch more photos with specific filters
            if (filter) {
                data = JSON.stringify(_.extend(nextPage, filter));
            }

            /*
             * This Ajax call performs a GET request by default;
             * Requesting more album photos or filtered photos requires posting data to a new URL
             */
            $.ajax({
                url: (album || filter) ? request.mediaItems + ':search' : request.mediaItems,
                type: (album || filter) ? 'POST' : 'GET',
                data: (album || filter) ? data : nextPage,
                contentType: (album || filter) ? 'application/json' : '',
                context: this,
                headers: {
                    'Authorization': this.token
                },
                success: function(resp) {
                    // check for more items to load
                    this.nextPageToken = resp.nextPageToken || null;
                    // add photos
                    this.add(resp.mediaItems);
                    // ajax doesn't trigger sync by default, unlike fetch
                    this.trigger('sync');
                }
            });
        }
    });

    App.reqres.setHandlers({
        // gets google photos from library or album
        'get:google:photos': function(token, album) {
            var albumData = '';
            var data = {
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                success: function(collection, response, options) {
                    // check for more items to load
                    this.nextPageToken = response.nextPageToken || null;
                    collection.nextPageToken = this.nextPageToken;
                },
                reset: true
            };

            var googlePhotosCollection = new Entities.GooglePhotos([], {
                url: request.mediaItems,
                token: 'Bearer ' + token
            });

            // if photos are from an album, create new object with POST params
            if (album) {
                albumData = _.extend(data, {
                    url: request.mediaItems + ':search',
                    method: 'POST',
                    data: {
                        'albumId': album.id
                    }
                });
            }
            googlePhotosCollection.fetch(album ? albumData : data);
            return googlePhotosCollection;
        },
        'get:google:albums': function(token) {
            // get google photos albums
            var googleAlbumsCollection = new Entities.GoogleAlbums([], {
                url: request.albums,
                token: 'Bearer ' + token
            });
            googleAlbumsCollection.fetch({
                url: request.albums,
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                success: function(collection, response, options) {
                    // check for more items to load
                    this.nextPageToken = response.nextPageToken || null;
                    collection.nextPageToken = this.nextPageToken;
                },
                reset: true
            });
            return googleAlbumsCollection;
        }
    });
});